export default __webpack_public_path__ + "static/media/SE-marketing-page-4.dd9fb1bb.jpg";